import {
  useQuery,
} from 'react-query';

import { useMiddleman } from '@hubins/middleman';

export const useScreenings = (profileUuid: string) => {
  const middleman = useMiddleman();

  return useQuery(['screening', profileUuid], () => {
    return middleman.promiseGet(`/ql/crm/screening/${profileUuid}`).then(res => res.data);
  }, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};